module.exports = __webpack_public_path__ + "img/2.3fcb83e7.jpg";